import { useTheme } from "./utils/theme";

const PlayerProfileMetric = ({ player }) => {
    const { theme: appTheme } = useTheme();
    const isDarkMode = true; // OLED: always dark
    return (
        <>
            {/* Key Performance Metrics and Awards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Key Performance Metrics */}
                <div className={`${"bg-gray-800 border-gray-700"} rounded-xl shadow-md border p-6`}>
                    <h3 className={`text-xl font-bold ${"text-white"} mb-6`}>
                        Key Performance Metrics
                    </h3>
                    <div className="space-y-3">
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                            <span className={`text-sm ${"text-gray-300"}`}>
                                Batting average of <span className="font-semibold">{player.battingAverage || ".285"}</span> over the season
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                            <span className={`text-sm ${"text-gray-300"}`}>
                                Current <span className="font-semibold text-yellow-600">.312 as of Player</span>
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                            <span className={`text-sm ${"text-gray-300"}`}>
                                {player.rbi || "15"} RBIs in conference play
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                            <span className={`text-sm ${"text-gray-300"}`}>
                                Caught stealing percentage <span className="font-semibold text-yellow-600">85%</span>
                            </span>
                        </div>
                    </div>
                </div>

                {/* Awards & Recognition */}
                <div className={`${"bg-gray-800 border-gray-700"} rounded-xl shadow-md border p-6`}>
                    <h3 className={`text-xl font-bold ${"text-white"} mb-6`}>
                        Awards & Recognition
                    </h3>
                    <div className="space-y-3">
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                            <span className={`text-sm ${"text-gray-300"}`}>
                                Two-time Pac-12 team champion
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                            <span className={`text-sm ${"text-gray-300"}`}>
                                All-Conference Honorable Mention (2023)
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                            <span className={`text-sm ${"text-gray-300"}`}>
                                Academic All-Pac-12 (2022, 2023)
                            </span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                            <span className={`text-sm ${"text-gray-300"}`}>
                                Team Captain (2024)
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* NIL Analytics */}
            <div className={`${"bg-gray-800 border-gray-700"} rounded-xl shadow-md border p-6`}>
                <h3 className={`text-xl font-bold ${"text-white"} mb-6`}>
                    NIL Analytics
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Marketability Score */}
                    <div className="text-center">
                        <div className={`text-sm ${"text-gray-400"} mb-2`}>
                            Marketability Score
                        </div>
                        <div className="flex items-center justify-center gap-1 mb-3">
                            <span className={`text-3xl font-bold ${"text-white"}`}>
                                74
                            </span>
                            <span className={`text-lg ${"text-gray-400"}`}>
                                /100
                            </span>
                        </div>
                        <div className={`w-full ${"bg-gray-700"} rounded-full h-2`}>
                            <div
                                className="bg-yellow-400 h-2 rounded-full transition-all duration-300"
                                style={{ width: "74%" }}
                            ></div>
                        </div>
                    </div>

                    {/* Social Audience */}
                    <div className="text-center">
                        <div className={`text-sm ${"text-gray-400"} mb-2`}>
                            Social Audience
                        </div>
                        <div className={`text-2xl font-bold ${"text-white"} mb-2`}>
                            Moderate
                        </div>
                        <div className="flex justify-center">
                            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                        </div>
                    </div>

                    {/* Est. NIL Value */}
                    <div className="text-center">
                        <div className={`text-sm ${"text-gray-400"} mb-2`}>
                            Est. NIL Value
                        </div>
                        <div className={`text-2xl font-bold ${"text-white"} mb-2`}>
                            $5K-15K
                        </div>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
                    {/* Top Brand Affiliates */}
                    <div>
                        <h4 className={`text-sm font-semibold ${"text-gray-300"} mb-4`}>
                            Top Brand Affiliates
                        </h4>
                        <div className="space-y-3">
                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <span className={`text-sm ${"text-gray-300"}`}>
                                        Sports Equipment
                                    </span>
                                    <span className={`text-sm font-semibold ${"text-white"}`}>
                                        85%
                                    </span>
                                </div>
                                <div className={`w-full ${"bg-gray-700"} rounded-full h-2`}>
                                    <div className="bg-yellow-400 h-2 rounded-full" style={{ width: "85%" }}></div>
                                </div>
                            </div>
                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <span className={`text-sm ${"text-gray-300"}`}>
                                        Apparel
                                    </span>
                                    <span className={`text-sm font-semibold ${"text-white"}`}>
                                        72%
                                    </span>
                                </div>
                                <div className={`w-full ${"bg-gray-700"} rounded-full h-2`}>
                                    <div className="bg-yellow-400 h-2 rounded-full" style={{ width: "72%" }}></div>
                                </div>
                            </div>
                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <span className={`text-sm ${"text-gray-300"}`}>
                                        Nutrition
                                    </span>
                                    <span className={`text-sm font-semibold ${"text-white"}`}>
                                        68%
                                    </span>
                                </div>
                                <div className={`w-full ${"bg-gray-700"} rounded-full h-2`}>
                                    <div className="bg-yellow-400 h-2 rounded-full" style={{ width: "68%" }}></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* NIL Opportunity Summary */}
                    <div>
                        <h4 className={`text-sm font-semibold ${"text-gray-300"} mb-4`}>
                            NIL Opportunity Summary
                        </h4>
                        <div className="space-y-3">
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                                <span className={`text-sm ${"text-gray-300"}`}>
                                    Strong local market presence in Bay Area
                                </span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                                <span className={`text-sm ${"text-gray-300"}`}>
                                    Growing social media engagement
                                </span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                                <span className={`text-sm ${"text-gray-300"}`}>
                                    High academic profile appeals to education brands
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PlayerProfileMetric